import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { useLocation, useNavigate } from "react-router";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { getOrdersDetailsAPI } from "../../api/order";
import { BASE_URL_IMG, RUPEES_SYMBOL } from "../../assets/constants";
import { Badge, Card, CardBody, CardHeader, Spinner } from "reactstrap";
import DataTable from "react-data-table-component";
import useLogout from "../../hooks/useLogout";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import LogoDark from "../../images/logo.png";

const OderDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [columns, setColumns] = useState([
    {
      name: "Doctor",
      selector: (row) => row?.product_name,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          <img
            src={row?.product_image ? `${BASE_URL_IMG}${row.product_image}` : "/default-avatar.png"}
            alt={row?.product_name || "User"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
          // onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.product_image)}
          />

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
              }}
              className="text-capitalize"
            >
              {row?.product_name || "N/A"}
            </span>
          </div>
        </div>
      ),
      sortable: true,
      width: "300px",
    },

    {
      name: "Qty",
      selector: (row) => row?.quantity,
      sortable: true,
      wrap: true,
    },
    {
      name: "Unit Price",
      selector: (row) => row?.unit_price,
      sortable: true,
      wrap: true,
    },
    {
      name: "Total",
      selector: (row) => row?.total,
      sortable: true,
      wrap: true,
    },
  ]);
  useEffect(() => {
    orderDetails();
  }, []);

  const orderDetails = () => {
    getOrdersDetailsAPI(location?.state)
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setData(res.data.data);
          setIsLoading(false);
        } else if (res.data.status === false) {
          setIsLoading(false);
          setData([]);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
        console.log("Response", res);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };
  const [filterText, setFilterText] = useState("");
  const filteredData =
    data?.items?.length > 0 &&
    data?.items?.filter((item) =>
      Object?.values(item)?.some(
        (value) => typeof value === "string" && value.toLowerCase().includes(filterText.toLowerCase())
      )
    );
  const handleSampleFileOpen = () => {
    // Replace 'sample_file.txt' with the name of your sample file
    const fileName = "sample file";
    var filePath;
    // Path to your sample file
    // if (selectedType?.value == "facility") {
    filePath = `http://192.168.23.11:3002/upload-test-catalog`; // Update the path
    // } else {
    //   filePath = `${base}${sampelFileV2}`; // Update the path
    // }
    const link = document.createElement("a");
    link.href = filePath;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  console.log(data, "data");

  return (
    <>
      <Head title={"Order Details"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>
                Order No <strong className="text-primary small">#{data?.order_no}</strong>
              </BlockTitle>
              <BlockDes className="text-soft">
                <ul className="list-inline">
                  <li>
                    Created At: <span className="text-base">{data?.date}</span>
                  </li>
                </ul>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Icon name={"arrow-left"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <div className="invoice">
            <div className="invoice-action">
              {/* <Link
                to={{
                  pathname: `${process.env.PUBLIC_URL}/invoice-print/${data.order_no}`,
                  state: { invoice: data },
                }}
                target="_blank"
              > */}
              {" "}
              {/* <Button size="lg" color="primary" onClick={handleSampleFileOpen} outline className="btn-icon btn-white btn-dim">
                <Icon name="printer-fill"></Icon>

              </Button> */}
              <Link to={`${process.env.PUBLIC_URL}/invoice-print/${data?.order_no}`} target="_blank">
                <Button size="lg" color="primary" outline className="btn-icon btn-white btn-dim">
                  <Icon name="printer-fill"></Icon>
                </Button>
              </Link>
              {/* </Link> */}
            </div>
            <div className="invoice-wrap">
              <div className="invoice-brand text-center">
                <img src={LogoDark} alt="" />
              </div>
              <div className="invoice-head">
                <div className="invoice-contact">
                  <span className="overline-title">Shipping To</span>
                  <div className="invoice-contact-info">
                    <h4 className="title">{data?.address?.full_name}</h4>
                    <ul className="list-plain">
                      <li>
                        <Icon name="map-pin-fill"></Icon>
                        <span>
                          {data?.address?.address}
                          <br />
                          {data?.address?.city}, {data?.address?.state}, {data?.address?.country}{" "}
                          {data?.address?.postal_code}
                        </span>
                      </li>
                      <li>
                        <Icon name="call-fill"></Icon>
                        <span>{data?.address?.mobile}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* BILLING ADDRESS */}
                <div className="invoice-contact">
                  <span className="overline-title">Billing To</span>

                  {data?.is_billing_same_as_shipping ? (
                    <div className="invoice-contact-info">
                      <h6 className="text-muted">Same as Shipping Address</h6>
                    </div>
                  ) : (
                    <div className="invoice-contact-info">
                      <h4 className="title">{data?.billing_Address?.full_name}</h4>
                      <ul className="list-plain">
                        <li>
                          <Icon name="map-pin-fill" />
                          <span>
                            {data?.billing_Address?.address}
                            <br />
                            {data?.billing_Address?.city},{" "}
                            {data?.billing_Address?.state},{" "}
                            {data?.billing_Address?.country}{" "}
                            {data?.billing_Address?.postal_code}
                          </span>
                        </li>
                        <li>
                          <Icon name="call-fill" />
                          <span>{data?.billing_Address?.mobile}</span>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>

                {/* <div className="invoice-contact">
                  <span className="overline-title">Invoice To</span>
                  <div className="invoice-contact-info">
                    <h4 className="title">{data?.address?.full_name}</h4>
                    <ul className="list-plain">
                      <li>
                        <Icon name="map-pin-fill"></Icon>
                        <span>
                          {data?.address?.address}
                          <br />
                          {data?.address?.city}, {data?.address?.state}, {data?.address?.country}{" "}
                          {data?.address?.postal_code}
                        </span>
                      </li>
                      <li>
                        <Icon name="call-fill"></Icon>
                        <span>{data?.address?.mobile}</span>
                      </li>
                    </ul>
                  </div>
                </div> */}

                <div className="invoice-desc">
                  <h3 className="title">Invoice</h3>
                  <ul className="list-plain">
                    <li className="invoice-id">
                      <span>Invoice ID</span>:<span>{data?.invoice_no}</span>
                    </li>
                    <li className="invoice-date">
                      <span>Date</span>:<span>{data?.date?.split(",")[0]}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="invoice-bills">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th className="w-150px">Item</th>
                        {/* <th className="w-60">Description</th> */}
                        <th></th>
                        <th>Price</th>
                        <th>Qty</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.items?.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.product_name}</td>
                          {/* <td>Dashlite - Conceptual App Dashboard - Regular License</td> */}
                          <td></td>
                          <td>
                            {RUPEES_SYMBOL}
                            {item?.unit_price || 0}
                          </td>
                          <td>{item?.quantity || 0}</td>
                          <td>
                            {RUPEES_SYMBOL}
                            {item?.total || 0}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="2"></td>
                        <td colSpan="2">Subtotal</td>
                        <td>
                          {RUPEES_SYMBOL}
                          {data?.subtotal || 0}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2"></td>
                        <td colSpan="2">Shipping fee</td>
                        <td>{data?.shipping_cost || 0}</td>
                      </tr>
                      <tr>
                        <td colSpan="2"></td>
                        <td colSpan="2">GST</td>
                        <td>{data?.tax || 0}</td>
                      </tr>
                      <tr>
                        <td colSpan="2"></td>
                        <td colSpan="2">Discount</td>
                        <td>{data?.discount || 0}</td>
                      </tr>
                      {data?.online_discount &&
                        <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Online Payment Discount (2%)</td>
                          <td>{data?.online_discount || 0}</td>
                        </tr>
                      }

                      <tr>
                        <td colSpan="2"></td>
                        <td colSpan="2">Ayucash</td>
                        <td>{data?.maxRedeemableAyuCash || 0}</td>
                      </tr>
                      <tr>
                        <td colSpan="2"></td>
                        <td colSpan="2">Coupon</td>
                        <td>{data?.coupon_name || "N/A"}</td>
                      </tr>
                      <tr>
                        <td colSpan="2"></td>
                        <td colSpan="2">Grand Total</td>
                        <td>
                          {RUPEES_SYMBOL}
                          {data.total_amount || 0}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Block>
        {/* <Block>
          <Row className={"g-gs mt-1"}>
            <Col sm="12">
              <PreviewAltCard>
                <CardHeader>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>{"Order Summary"}</h5>
                    <div className="search-box d-flex justify-content-end"></div>
                  </div>

                </CardHeader>
                <div className="row">
                  <div className="col-3">
                    <div className="card-inner card-bordered">
                      <div className="aside-wg">
                        <h6 className="overline-title-alt mb-2">Delivery Information</h6>
                        <ul className="user-contacts">
                          <li>
                            <Icon name="user"></Icon>
                            <span>{data?.address?.full_name}</span>
                          </li>
                          
                          <li>
                            <Icon name="call"></Icon>
                            <span>{data?.address?.mobile}</span>
                          </li>
                          <li>
                            <Icon name="map-pin"></Icon>
                            <span>
                              {data?.address?.address}
                              <br />
                              {data?.address?.city}, {data?.address?.state}, {data?.address?.country}{" "}
                              {data?.address?.postal_code}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-9">
                    <div className="card-inner">
                      <div className="aside-wg">
                        <h6 className="overline-title-alt mb-2">Order Summary</h6>
                        <ul className="user-contacts row px-2">
                          <li className="col-md-4">
                            <span className="data-label">Coupon</span>
                            <span className="data-value">{data?.coupon_name || "N/A"}</span>
                          </li>

                          <li className="col-md-4">
                            <span className="data-label">AYU Cash</span>
                            <span className="data-value">{data?.ayu_cash || 0}</span>
                          </li>
                          <li className="col-md-4">
                            <span className="data-label">Sub Total : </span>
                            <span>{data?.subtotal}</span>
                          </li>
                          <li className="col-md-4">
                            <span className="data-label">Status</span>
                            <span className="data-value">
                              <Badge
                                size="sm"
                                color={
                                  data?.order_status === "Delivered"
                                    ? "outline-success"
                                    : data?.order_status === "pending"
                                    ? "outline-info"
                                    : "outline-danger"
                                }
                                className="badge-dim text-capitalize"
                              >
                                {data?.order_status}
                              </Badge>
                            </span>
                          </li>
                          <li className="col-md-4">
                            <span className="data-label">GST</span>
                            <span className="data-value">{data?.tax}</span>
                          </li>
                          <li className="col-md-4">
                            <span className="data-label">Discount</span>
                            <span className="data-value">{data?.discount || 0}</span>
                          </li>
                          <li className="col-md-4">
                            <span className="data-label">Order Date</span>
                            <span className="data-value">{data?.date}</span>
                          </li>
                          <li className="col-md-4">
                            <span className="data-label">Shipping</span>
                            <span className="data-value">{data?.shipping_cost}</span>
                          </li>

                          

                          <li className="col-md-4">
                            <span className="data-label">
                              <strong>Total</strong>
                            </span>
                            <span className="data-value">
                              <strong>{data?.total_amount}</strong>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <CardBody>
                  <div className="data-table-container">
                    <DataTable
                      className="my-custom-table"
                      columns={columns}
                      data={data?.items}
                      progressPending={isLoading}
                      pagination
                      paginationResetDefaultPage={false}
                      progressComponent={
                        <Spinner color="primary" style={{ height: "3rem", width: "3rem" }} type="grow">
                          Loading...
                        </Spinner>
                      }
                      subHeader={false}
                      persistTableHead
                      striped
                      responsive
                      highlightOnHover
                      paginationRowsPerPageOptions={[25, 50, 100, 500]}
                      paginationPerPage={25}
                    />
                  </div>
                </CardBody>
              </PreviewAltCard>
            </Col>
          </Row>
        </Block> */}
      </Content>
    </>
  );
};

export default OderDetails;
